import RecoverStep from "./recover_step";
import {AJAX_DATA_TYPE_JSON} from "../utils/recover_consts";

const TEMPLATE = 'restore';

export default class Restore extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        // DB insert
        $.ajax({
            type: "POST",
            url: "/download/insert_download_session",
            data: JSON.stringify({
                appliance_id: data.recovery.appliance_id,
                device_id: data.recovery.device_asid,
                job_id: data.recovery.job_id,
                restore_point: data.recovery.point,
                drive: data.recovery.drive || '',
                path: data.restore.selected,
                download_type: data.restore.download_type,
                files_count: data.restore.counters.filesCounter,
                folders_count: data.restore.counters.foldersCounter
            }),
            success: function (response) {
                // Insert failed
                if (response['insert_result'] == 0) {
                    fr.goTo('error');
                }
                data.restore.download_link = response['download_url'];
                data.render.show = false;
                setTimeout(function () {
                    data.render.show = true;
                    fr.render('restore');
                }, 1500);
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }


}
